var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCafeHome(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 13,
    viewBox: "0 0 19 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 0.125H4.0625C3.81641 0.125 3.625 0.34375 3.625 0.5625V7.5625C3.625 8.79297 4.58203 9.75 5.8125 9.75H11.9375C13.1406 9.75 14.125 8.79297 14.125 7.5625V7.125H15C16.9141 7.125 18.5 5.56641 18.5 3.625C18.5 1.71094 16.9141 0.125 15 0.125ZM12.8125 7.5625C12.8125 8.05469 12.4023 8.4375 11.9375 8.4375H5.8125C5.32031 8.4375 4.9375 8.05469 4.9375 7.5625V1.4375H12.8125V7.5625ZM15 5.8125H14.125V1.4375H15C16.2031 1.4375 17.1875 2.42188 17.1875 3.625C17.1875 4.85547 16.2031 5.8125 15 5.8125ZM16.5039 12.375C17.543 12.375 17.8984 11.0625 17.3789 11.0625H1.21875C0.726562 11.0625 1.05469 12.375 2.09375 12.375H16.5039Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCafeHome);
export default __webpack_public_path__ + "static/media/cafe-home.efec8305.svg";
export { ForwardRef as ReactComponent };